export default "app-button {\n  left: 0.6rem !important;\n  bottom: auto !important;\n}";